<template>
  <div class="w-full h-screen relative bg-gray-50">
    <!-- Loading State -->
    <div
      v-if="trackingStore.state.loading"
      class="flex flex-col items-center justify-center h-full"
    >
      <div
        class="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"
      ></div>
      <p class="mt-4 text-gray-600 font-semibold">Chargement des informations...</p>
    </div>

    <!-- Error State -->
    <div
      v-else-if="trackingStore.state.error"
      class="flex items-center justify-center h-full px-4"
    >
      <div class="bg-white rounded-[2rem] p-8 text-center shadow-xl max-w-md w-full border border-gray-100">
        <div
          class="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h2 class="text-xl font-bold text-gray-800 mb-2">
          Impossible de récupérer le suivi
        </h2>
        <p class="text-gray-500 mb-6 text-sm">{{ trackingStore.state.error }}</p>
        <button
          @click="goBack"
          class="w-full py-3 bg-primary text-white font-bold rounded-xl hover:bg-primary-600 transition-colors shadow-lg shadow-primary/20"
        >
          Retour
        </button>
      </div>
    </div>

    <!-- Tracking Data View -->
    <div
      v-else-if="trackingStore.state.data"
      class="w-full h-full"
    >
      <!-- Order tracking view -->
      <OrderDetails
        v-if="trackingStore.state.type === 'order'"
        :orderData="trackingStore.state.data"
        @close="goBack"
      />
      <!-- Package tracking view -->
      <PackageDetails
        v-else-if="trackingStore.state.type === 'package'"
        :deliveryData="trackingStore.state.data"
        @close="goBack"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import constants from '@core/utils/constants';
import OrderDetails from '@features/orders/components/OrderDetails.vue';
import PackageDetails from '@features/packages/components/PackageDetails.vue';

const route = useRoute();
const router = useRouter();
const trackingStore = getStore('tracking');

onMounted(() => {
  // Load tracking data
  let { type: routeType, code: routeCode } = route.params;
  
  if (!routeCode && route.params.code) {
    routeCode = route.params.code;
  }
  
  if (!routeType && routeCode) {
    // If only code is provided in route /track/:code
    routeType = routeCode.toUpperCase().startsWith('ORD') ? 'order' : 'package';
  }

  if (routeCode) {
    bus.emit(constants.EVENTS.TRACKING.BY_CODE, {
      type: routeType || 'package',
      code: routeCode
    });
  }
});

function goBack() {
  router.push('/');
}
</script>
